<template>
    <b-modal
        lazy
        title-tag="h2"
        title="Other Clinics"
        :visible="isOpen"
        footer-class="d-flex justify-content-between"
    >
        <div>
            <b-table-simple responsive class="table table-sm borderless">
                <b-thead>
                    <b-tr>
                        <b-th>Clinic:</b-th>
                        <b-th>Balance:</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr
                        v-for="(record, index) in _.sortBy(clinicData, [
                            function (o) {
                                return o.account_balance;
                            }
                        ]).reverse()"
                        :key="index"
                    >
                        <b-td>
                            {{ index + 1 }}. {{ record.business_name }}
                        </b-td>
                        <b-td>
                            {{ _toCurrency(record.account_balance) }}
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </b-modal>
</template>
<script type="text/javascript">
export default {
    data() {
        return {
            clinicData: null,
            isOpen: false
        };
    },
    methods: {
        open(arrayOfClinics) {
            this.clinicData = arrayOfClinics;
            this.isOpen = true;
        }
    }
};
</script>
<style lang="scss">
.borderless td,
.borderless th {
    border: none;
}
</style>
